export type BoardImagePrefetchRules = {
  concurrency: number;
  enabled: boolean;
  prefetchOnReducedData: boolean;
  reducedDataConcurrency: number;
  startDelayMs: number;
};

// Set enabled to false to disable all landing/lobby image prefetching.
export const BOARD_IMAGE_PREFETCH_RULES: BoardImagePrefetchRules = {
  concurrency: 4,
  enabled: true,
  prefetchOnReducedData: true,
  reducedDataConcurrency: 2,
  startDelayMs: 1200,
};
